import { ZERO } from 'config/_const';
import * as ChartsConfig from '../../medium/side-menu/side-menu-widget/ApexChartsConfig';

export const earningOptions = {
  ...ChartsConfig.chart33Options,
  colors: ['#f68d5c'],
  stroke: {
    color: 'red',
  },
  fill: {
    color: 'red',
  },
  yaxis: {
    show: true,
  }
};

export const accountOptions = {
  ...ChartsConfig.chart33Options,
  colors: ['#33d2a6'],
  stroke: {
    color: 'yellow',
  },
  fill: {
    color: 'yellow',
  },
  yaxis: {
    show: true,
  }
};

export const portfolioOptions = (categories: string[]) => ({
  ...ChartsConfig.chart33Options,
  colors: ['#7180E3'],
  stroke: {
    width: 2,
    color: 'green',
    curve: 'smooth'
  },
  fill: {
    opacity: 0.1,
    color: 'green',
    gradient: {
      shade: 'light',
      type: "vertical",
      shadeIntensity: 0.3,
      gradientToColors: undefined,
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 0.3,
      stops: [0, 90, 100],
      colorStops: []
    }
  },
  yaxis: {
    show: true,
  },
  xaxis: {
    show: false,
    categories: categories
  }
});

export const priceHistoryOptions = (categories: string[]) => ({
  ...ChartsConfig.chart33Options,
  colors: ['#ae67fe'],
  stroke: {
    width: 2,
    color: 'green',
    curve: 'smooth'
  },
  fill: {
    opacity: 0.1,
    color: 'green',
    gradient: {
      shade: 'light',
      type: "vertical",
      shadeIntensity: 0.3,
      gradientToColors: undefined,
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 0.3,
      stops: [0, 90, 100],
      colorStops: []
    }
  },
  xaxis: {
    categories,
  },
  yaxis: {
    show: true,
    min: 1
  },
  dataLabels: {
    enabled: false
  }
});

export const assetProfilePriceHistoryOptions = (categories: string[]) => ({
  colors: ['#6677F5'],
  chart: {
    toolbar: {
      show: false
    }
  },
  xaxis: {
    categories: categories,
    labels: {
      show: false
    },
    axisTicks: {
      show: false
    }
  },
  yaxis: {
    show: false,
  },
  grid: {
    show: false
  },
  stroke: {
    width: 4,
    color: 'green',
    curve: 'smooth'
  },
  fill: {
    opacity: 0.1,
    color: 'green',
    gradient: {
      shade: 'light',
      type: "vertical",
      shadeIntensity: 0.2,
      gradientToColors: undefined,
      inverseColors: false,
      opacityFrom: 0.5,
      opacityTo: 0.1,
      stops: [0, 90],
      colorStops: []
    }
  },
  dataLabels: { enabled: false },
  style: { padding: 0, margin: 0 },
  tooltip: {
    enabled: true,
    x: { show: false },
    y: {
      formatter: (val: string) => {
        return Number(val).toCurrency();
      },
      title: {
        formatter: () => ""
      }
    },
    marker: { show: false },
  }
});

export const assetProfileScoreHistoryOptions = (categories: string[], scalesY: number[], canShowLegend?: boolean) => ({
  colors: ['#53D081'],
  chart: {
    toolbar: {
      show: false
    }
  },
  xaxis: {
    categories: categories,
    labels: {
      show: false
    },
    axisTicks: {
      show: false
    }
  },
  yaxis: {
    show: false,
  },
  grid: {
    show: false
  },
  stroke: {
    width: 3,
    color: 'green',
    curve: 'smooth'
  },
  fill: {
    opacity: 0.5,
    color: 'green',
    type: "gradient",
    gradient: {
      shade: 'light',
      type: "vertical",
      shadeIntensity: 1,
      gradientToColors: undefined,
      inverseColors: false,
      opacityFrom: 0.7,
      opacityTo: 0.7,
      stops: [0, 70, 100],
      colorStops: []
    }
  },
  dataLabels: { enabled: false },
  style: { padding: 0, margin: 0 },
  tooltip: {
    enabled: true,
    x: { show: false },
    y: {
      formatter: (val: string, { seriesIndex }: { seriesIndex: number }) => {
        const valInNum = (parseFloat(val) < ZERO) ? ZERO : parseFloat(val);
        return Math.round(valInNum / (scalesY[seriesIndex] || 1));
      },
      title: {
        formatter: () => ""
      }
    },
    marker: { show: false },
  },
  legend: {
    show: canShowLegend ?? true,
    position: "top",
    horizontalAlign: "left",
    showForSingleSeries: true,
    fontSize: "16px",
    labels: {
      useSeriesColors: true,
    },
    markers: {
      offsetX: "-10px"
    },
    onItemClick: { toggleDataSeries: false }
  }
});

export const noPriceHistoryOptions = (categories: string[]) => ({
  ...ChartsConfig.chart33Options,
  colors: ['#ae67fe'],
  stroke: {
    width: 2,
    color: 'green',
    curve: 'smooth'
  },
  fill: {
    opacity: 0.1,
    color: 'green',
    gradient: {
      shade: 'light',
      type: "vertical",
      shadeIntensity: 0.3,
      gradientToColors: undefined,
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 0.3,
      stops: [0, 90, 100],
      colorStops: []
    }
  },
  xaxis: {
    categories,
    position: 'top',
    crosshairs: {
      width: 0
    },
  },
});
